import { service } from './service'

import { config } from './config'

import qs from 'qs'
import { useAuthStoreWithOut } from '@/store/modules/auth'
import { useCommonStoreWithOut } from '@/store/modules/common'
const commonStore = useCommonStoreWithOut()

const authStore = useAuthStoreWithOut()
const { default_headers } = config
const DOMAIN_KEY = 'portal'
function getBaseURL (baseUrl) {
  if ((window as any).$dcorigin.search(DOMAIN_KEY) !== -1) {
    let url = (window as any).$dcorigin
    const reg = new RegExp('-\\d+-\\d+-\\d+')
    url = url.replace(reg, '')
    const key = 'portal-simplebi'
    let replaceStr = 'portal-apm', joinStr = ''
    switch (baseUrl) {
      case 'm2i':
        replaceStr = 'api-m2i'
        joinStr = 'm2i'
        break;
      case 'bi':
        replaceStr = 'api-bi'
        joinStr = ''
        break;
      case 'apm-dis':
        replaceStr = 'apm-dis'
        break;
      case 'msgpush':
        replaceStr = 'messagepush'
        joinStr = ''
        break;
      case 'api-desk':
        replaceStr = 'desk-app-management'
        joinStr = ''
        break;
      case 'api-apm':
        replaceStr = 'portal-apm'
        joinStr = 'api-apm'
        break;
      case 'apm-auth':
        joinStr = ''
        break;        
      case 'apm-dashboard-api':
          replaceStr = 'apm-dashboard-api'
          joinStr = ''
          break; 
      case 'apm-dws':
        console.log('--------------apm-dws')
        if(url.includes('wiseiot-cluster01.axa-dev2.wise-paas.top')){
         url = url.replace('wiseiot', 'wiseiot2') 
        }        
        joinStr = 'apm-dws'
        break; 
      case 'api-ireport':
        console.log('--------------api-ireport')
        if(url.includes('wiseiot-cluster01.axa-dev2.wise-paas.top')){
          url = url.replace('wiseiot', 'wiseiot2') 
        } 
        replaceStr = 'api-ireport'       
        // joinStr = 'api-ireport'
        break;                          
      default:      
        return baseUrl
    }
    url = `${url.replace(key, replaceStr)}${joinStr}`
    return url
  }
  return baseUrl
}

const request = (option: any) => {
  const { url, method, params, data, headersType, responseType,baseUrl,header } = option
  let withCredentials = option.withCredentials
  if (withCredentials === undefined) withCredentials = true
  // console.log('request option',option)
  const headers = header?header:{}
  if (!headers['org-id'] && !url.includes('AdvStreamingService')) {
    let orgId = authStore.getOrgInfo.id
    if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
    headers['org-id'] = orgId
  }
  if (process.env.NODE_ENV !== 'production') {
    if(url && ['api-apm','apm-push'].includes(baseUrl)){
      // headers['Tenant-Id'] = 'cluster01a99c5e30-006b-11eb-8201-00d8613dec81m2idemo'
      headers['Tenant-Id'] = '9eac64c330a5457a8f20b88f7279029b'
    }
  }
  if(baseUrl=='api-desk'&&(window as any).$wujie){
    headers['Tenant-Id'] = (window as any).$wujie.props.tenantId
  }
  
  const opts:any = {
    baseURL: getBaseURL(baseUrl),
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    withCredentials: withCredentials,
    headers: {
      'Content-Type': headersType || default_headers,
      ...headers
    },
    paramsSerializer : params => {
      return qs.stringify(params, { indices: false })
    }  
  }
  return service(opts)
}
export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
